import type { Clip, Module, StackItem } from "./types"

/** On phones, a single full-screen image (or clip) of the desktop layout stands
 *  alone on a tall screen. So, on phones, a case's single images are brought
 *  together onto one screen, in their order: the first one's screen takes the
 *  next ones in (even with other layouts between them), up to three. Never two
 *  clips together: a clip goes with one still at most. */
const MAX = 3

const single = (m: Module): StackItem | null => {
    if (m.type === "video") return { image: m.image, clip: { src: m.video.src }, w: 16, h: 9 }
    if (m.type !== "grid" || m.columns.length !== 1 || m.columns[0].cells.length !== 1) return null
    const c = m.columns[0],
        x = c.cells[0]
    if (!x.image || x.card || x.tag || x.w) return null
    // (full width only: the desktop's 16:9-ish screen fillers)
    if (c.w < 1400) return null
    return { image: x.image, clip: x.clip, w: c.w, h: x.h }
}

const fits = (group: StackItem[], it: StackItem) => {
    if (group.length >= MAX) return false
    const clips = group.filter((g) => g.clip).length + (it.clip ? 1 : 0)
    if (clips > 1) return false
    // a clip goes with one still at most
    if (clips === 1 && group.length + 1 > 2) return false
    return true
}

export function groupForPhone(modules: Module[]): Module[] {
    const out: (Module | { type: "stack"; items: StackItem[] })[] = []
    let open: { items: StackItem[] } | null = null
    for (const m of modules) {
        const it = single(m)
        if (!it) {
            out.push(m)
            continue
        }
        if (open && fits(open.items, it)) {
            open.items.push(it)
            continue
        }
        open = { type: "stack", items: [it] } as any
        out.push(open as any)
    }
    // a group of one stays as it was designed
    return out.map((m, i) => (m.type === "stack" && m.items.length === 1 ? (modules.find((x) => single(x)?.image === m.items[0].image) as Module) : m)) as Module[]
}

export type { Clip }
